import React, { lazy, Suspense, useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { ThemeProvider } from "@emotion/react";
import { ToastContainer } from 'react-toastify';
import BackDrop from "components/backDrop/BackDrop";
import AppError from "./components/error/Error";
import { companyDetailsEnum } from 'utils/companyDetails';
import { theme } from "./theme";
import colorConfig from "utils/colorConfig";
import "assets/styles/Style.scss";


const AppRouter = lazy(() =>
  import(/* webpackChunkName: "App" */ "./routes/AppRoutes")
);

function App() {
  
  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
    }
    link.href = companyDetailsEnum?.favicon;
    document.title = companyDetailsEnum?.companyName;
    
    // Set CSS custom properties for colors from environment variables
    document.documentElement.style.setProperty('--color-primary', colorConfig.primary);
    document.documentElement.style.setProperty('--color-secondary', colorConfig.secondary);
    document.documentElement.style.setProperty('--color-black', colorConfig.black);
    document.documentElement.style.setProperty('--color-grey', colorConfig.grey);
    document.documentElement.style.setProperty('--color-medium-grey', colorConfig.mediumGrey);
    document.documentElement.style.setProperty('--color-light-grey', colorConfig.lightGrey);
    document.documentElement.style.setProperty('--color-red', colorConfig.red);
    document.documentElement.style.setProperty('--color-green', colorConfig.green);
    document.documentElement.style.setProperty('--color-blue', colorConfig.blue);
    document.documentElement.style.setProperty('--color-yellow', colorConfig.yellow);
    document.documentElement.style.setProperty('--color-violet', colorConfig.violet);
    document.documentElement.style.setProperty('--color-white', colorConfig.white);
    document.documentElement.style.setProperty('--color-light-blue', colorConfig.lightBlue);
    document.documentElement.style.setProperty('--color-sky-blue', colorConfig.skyBlue);
    document.documentElement.style.setProperty('--color-light-pink', colorConfig.lightPink);
    document.documentElement.style.setProperty('--color-light-orange', colorConfig.lightOrange);
    document.documentElement.style.setProperty('--color-dark-red', colorConfig.darkRed);
    document.documentElement.style.setProperty('--color-light-green', colorConfig.lightGreen);
    document.documentElement.style.setProperty('--color-light-black', colorConfig.lightBlack);
}, []);

  return (
    <ThemeProvider theme={theme}>
    <Suspense fallback={<div className="loading" />}>
      <ErrorBoundary FallbackComponent={AppError}>
        <AppRouter />
        <BackDrop />
        <ToastContainer />
      </ErrorBoundary>
    </Suspense>
    </ThemeProvider>
  );
}

export default App;
